import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";
import { baseURL } from "../../Config/config";
import { Box } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, formLabelClasses, TextField } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Projectcolors from "../../Utils/Colors";
import AddBusinessUser from "./AddBusinessUser";
import GlobalLoader from "./GlobalLoader";
import {IconButton} from "@mui/material";
import Typography from "@mui/material/Typography";

const tableHead = [
  "Username",
  "Password",
  "Full Name",
  "Title / Role",
  "Company",
  "Workspace",
  "Edit",
  "Delete",
];
export default function BusinessUsersTable(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [usersArray, setUsersArray] = React.useState([]);
  const [isEdit, setIsEdit] = React.useState();
  const [username, setUsername] = React.useState();
  const [password, setPassword] = React.useState();
  const [modalState, setModalState] = React.useState(false);
  const [pageUpdater, setPageUpdater] = React.useState(0);
  const [loader, setLoader] = React.useState(false);

const [fullName, setFullName] = React.useState("");
const [title, setTitle] = React.useState("");
const [company, setCompany] = React.useState("");
const [workspace, setWorkspace] = React.useState("");


  const toggleModal = (value) => {
    setModalState(value);
  };

  useEffect(async () => {
    await getAllbusinessusers();
  }, [pageUpdater]);

  const refreshList = async(value) => {  

    if(value){
      await getAllbusinessusers();
      return;
    }
    return;

  }


  const deletebusinessUser = async (id) => {
    const body = {
      userID: id,
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };

    try {
      setLoader(true)
      let result = await fetch(`${baseURL}/deletebusinessuser`, options);
      result = await result.json();
      if (result.code) {
        // setPageUpdater(pageUpdater + 1)
        // window.location.reload();
        await getAllbusinessusers()
        setLoader(false)
        return;
      }
      alert("There was some error");
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.log("error", error);
    }
  };

 const getAllbusinessusers = async () => {
  try {
    setLoader(true);

    let result = await fetch(`${baseURL}/getallbusinessusers`);
    result = await result.json();

    if (result.code) {
      const data = [];

      result.data.forEach((item) => {
        data.push({
          id: item.user_id,

          username: item.username || "",
          password: item.password || "",

          full_name: item.full_name || "",
          title: item.title || "",
          company: item.company || "",
          workspace_id: item.workspace_id || "",

          editState: false,
        });
      });

      setIsEdit(data);
      setUsersArray(result.data);

      props.setTotalUsers(result.data.length);

      setLoader(false);
      return;
    }

    alert("There was some error");
    setLoader(false);

  } catch (error) {
    setLoader(false);
    console.log("error", error);
  }
};

 const handleUpdateUserApi = async (id) => {
  const body = {
    userID: id,

    username: username,
    password: password,

    full_name: fullName,
    title: title,
    company: company,
    workspace_id: workspace,
  };

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };

  try {
    setLoader(true);

    let result = await fetch(
      `${baseURL}/updatebusinessuser`,
      options
    );

    result = await result.json();

    if (result.code) {
      await getAllbusinessusers();

      // Clear edit values
      setUsername("");
      setPassword("");
      setFullName("");
      setTitle("");
      setCompany("");
      setWorkspace("");

      setLoader(false);
      return;
    }

    setLoader(false);
    alert(result.message || "There was some error");

  } catch (error) {
    setLoader(false);
    console.log("error", error);
    alert("There was some error");
  }
};

 const handleUpdate = async (i, id) => {
  await handleUpdateUserApi(id);
};

const editFunc = (u, i, value) => {
  const data = [...isEdit];

  setIsEdit(
    data.map((d, idx) => {
      if (d.id === u) {
        setUsername(d.username || "");

        // Leave blank unless admin wants to change password
        setPassword("");

        setFullName(d.full_name || "");
        setTitle(d.title || "");
        setCompany(d.company || "");
        setWorkspace(d.workspace_id || "");

        return {
          ...d,
          editState: value
        };
      }

      return d;
    })
  );
};



 return (
  <Box
    sx={{
      backgroundColor: "#fff",
      borderRadius: "16px",
    }}
  >
    {/* HEADER */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        background: "#f8fafc",
         px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
      }}
    >

      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#1e293b",
        }}
      >
        Project & Business User Management
      </Typography>

      <Button
        onClick={() => toggleModal(true)}
        variant="contained"
        sx={{
          textTransform: "none",
          borderRadius: "10px",
          px: 2.5,
          py: 1,
          fontWeight: 600,
          background:
            "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
          boxShadow: "0 6px 15px rgba(0,0,0,0.12)",
          ":hover": {
            background:
              "linear-gradient(90deg, #095c9c 0%, #1f8bc7 100%)",
          },
        }}
      >
        Add User
      </Button>
    </Box>

    {/* TABLE */}
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        maxHeight: "60vh",
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {tableHead.map((item) => (
              <TableCell
                key={item}
                sx={{
                  backgroundColor: "#f8fafc",
                  fontWeight: 700,
                  fontSize: "13px",
                  color: "#334155",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {usersArray &&
            isEdit &&
            usersArray.map((item, idx) => (
              <TableRow
                hover
                key={idx}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f8fbff",
                  },
                }}
              >
                {/* USERNAME */}
                <TableCell sx={{ fontSize: "13px" }}>
                  {isEdit[idx]?.editState ? (
                    <TextField
                      variant="outlined"
                      defaultValue={item.username}
                      onChange={(e) =>
                        setUsername(e.target.value)
                      }
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                        },
                      }}
                    />
                  ) : (
                    item.username
                  )}
                </TableCell>

                {/* PASSWORD */}
                <TableCell sx={{ fontSize: "13px" }}>
                  {isEdit[idx]?.editState ? (
                    <TextField
                      type="password"
                      variant="outlined"
                      defaultValue={item.password}
                      onChange={(e) =>
                        setPassword(e.target.value)
                      }
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                        },
                      }}
                    />
                  ) : (
                    item.password
                  )}
                </TableCell>
                {/* FULL NAME */}
<TableCell sx={{ fontSize: "13px" }}>
  {isEdit[idx]?.editState ? (
    <TextField
      value={fullName}
      onChange={(e) => setFullName(e.target.value)}
      size="small"
      fullWidth
      InputProps={{
        style: {
          fontSize: "13px",
          borderRadius: "8px",
        },
      }}
    />
  ) : (
    item.full_name || "-"
  )}
</TableCell>

{/* TITLE */}
<TableCell sx={{ fontSize: "13px" }}>
  {isEdit[idx]?.editState ? (
    <TextField
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      size="small"
      fullWidth
      InputProps={{
        style: {
          fontSize: "13px",
          borderRadius: "8px",
        },
      }}
    />
  ) : (
    item.title || "-"
  )}
</TableCell>

{/* COMPANY */}
<TableCell sx={{ fontSize: "13px" }}>
  {isEdit[idx]?.editState ? (
    <TextField
      value={company}
      onChange={(e) => setCompany(e.target.value)}
      size="small"
      fullWidth
      InputProps={{
        style: {
          fontSize: "13px",
          borderRadius: "8px",
        },
      }}
    />
  ) : (
    item.company || "-"
  )}
</TableCell>

{/* WORKSPACE */}
<TableCell sx={{ fontSize: "13px" }}>
  {isEdit[idx]?.editState ? (
    <TextField
      value={workspace}
      onChange={(e) => setWorkspace(e.target.value)}
      size="small"
      fullWidth
      InputProps={{
        style: {
          fontSize: "13px",
          borderRadius: "8px",
        },
      }}
    />
  ) : (
    item.workspace_id || "-"
  )}
</TableCell>

<TableCell>
  {isEdit[idx]?.editState ? (
    <TextField
      value={item.workspace_id}
      onChange={(e) => setWorkspace(e.target.value)}
      size="small"
    />
  ) : (
    item.workspace_id || "-"
  )}
</TableCell>

                {/* EDIT */}
                <TableCell>
                  {isEdit[idx]?.editState ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() =>handleUpdate(idx,item.user_id)}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          background:
                            "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
                          boxShadow: "none",
                        }}
                      >
                        Update
                      </Button>

                      <CancelIcon
                        onClick={() =>
                          editFunc(
                            item.user_id,
                            idx,
                            false
                          )
                        }
                        sx={{
                          color: "#dc2626",
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  ) : (
                    <IconButton>
                      <EditIcon
                        onClick={() =>
                          editFunc(
                            item.user_id,
                            idx,
                            true
                          )
                        }
                        sx={{
                          color: "#2563eb",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  )}
                </TableCell>

                {/* DELETE */}
                <TableCell>
                  <IconButton>
                    <DeleteIcon
                      sx={{
                        color: "#dc2626",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        deletebusinessUser(item.user_id)
                      }
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>

    {/* MODAL */}
    <AddBusinessUser
      modalState={modalState}
      refreshList={refreshList}
      toggleModal={toggleModal}
    />

    {/* LOADER */}
    {loader ? <GlobalLoader /> : null}
  </Box>
);
}
